const companies = {
  title: "Companies",
  new_company: "New Company",
  edit_company: "Edit Company: {name}",
  view_company: "View Company: {name}",
  list_title: "List of Companies",
  list_subtitle: "Manage Company",
  create_title: "Create New Company",
  update_title: "Update Classroom",
  company_access: "Company access",
  employees: "Employees",
  id: "ID",
  name: "Name",
  vat: "VAT",
  requested_access: "Requested Access",
  confirm_approve_request: "Are you sure you want to approve this user?",
  confirm_reject_request: "Are you sure you want to reject this user?",
  confirm_add_users: "Are you sure you want to add the selected user(s)?",
  approve_success: "User successfully approved.",
  approve_failed: "Failed to approve user.",
  add_users_success: "User(s) successfully added.",
  reject_success: "User successfully rejected.",
  reject_failed: "Failed to reject user.",
  add_users_failed: "Failed to add selected user(s)",
  issued_date: "Issued Date",
  active_until: "Active Until",
  vat_does_not_exist: "VAT does not exist",
}
export default companies
